import * as React from 'react'
import Milliseconds from '../../../helper/milliseconds'
import LargeNumber from '../../../helper/large-number'

interface Props {
    message?: {
        args: {
            ct: number
            wt: number
        }
    }
}

export default class OrmMetadataCache extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        const doctrineLink = 'https://www.doctrine-project.org/projects/doctrine-orm/en/3.3/reference/caching.html#metadata-cache'
        const symfonyLink = 'https://symfony.com/doc/current/reference/configuration/doctrine.html#doctrine-orm-configuration'

        let info = <p>In this trace Doctrine ORM Metadata was parsed from the configuration and not loaded from cache.</p>

        if (message) {
            info = (
                <p>
                    In this trace Doctrine ORM Metadata was parsed from the configuration and not loaded from cache{' '}
                    <LargeNumber value={message.args.ct} class="" /> times for <Milliseconds value={message.args.wt} />.
                </p>
            )
        }

        return (
            <div>
                {info}

                <p>
                    This could indicate that metadata caching is not enabled, which is highly recommended in production uses of Doctrine
                    ORM. See the <a href={doctrineLink}>Doctrine documentation</a> or the{' '}
                    <a href={symfonyLink}>Symfony Doctrine Bundle configuration</a> on how to enable the configuration.
                </p>
            </div>
        )
    }
}
